
export default function utils() {
 // Listen to tab events to enable outlines (accessibility improvement)
  var root = document.getElementsByTagName( 'html' )[0]; // '0' to assign the first (and only `HTML` tag)
  var currentclass = root.className + ' no-focus-outline'; // Add to existing classes

  root.setAttribute( 'class', currentclass);

  document.body.addEventListener('keyup', function(e) {
    if (e.which === 9) /* tab */ {
      document.documentElement.classList.remove('no-focus-outline');
    }
  });

  var tx = document.getElementsByTagName('textarea');
  for (var i = 0; i < tx.length; i++) {
    tx[i].setAttribute('style', 'height:' + (tx[i].scrollHeight) + 'px;overflow-y:hidden;');
    if (tx[i].id === 'm0x8p4t') {
      tx[i].style.marginBottom = 'auto';
    }
    tx[i].addEventListener("input", OnInput, false);
  }

  function OnInput() {
    this.style.height = 'auto';
    this.style.height = (this.scrollHeight) + 'px';
  }

  function initExpandables() {
    for (let elem of document.querySelectorAll('.pillars-accordion .pillar-item')) {
      const expand = elem.querySelector('.expand');
      const collapse = elem.querySelector('.collapse');

      if (expand)
        expand.addEventListener("click", (e) => {
          e.preventDefault();
          expand.closest('.expandable').classList.add('expanded');
        });

      if (collapse)
        collapse.addEventListener("click", (e) => {
          e.preventDefault();
          collapse.closest('.expandable').classList.remove('expanded');
        });

    }
  }
  initExpandables();

  function manageContactDetails() {
    let button = document.querySelector('.manage-contact-details');

    if (button == null) return;

    button.addEventListener('click', (e) => {
      e.preventDefault();
      let container = document.querySelector('.ad-contact'),
          text = button.querySelector('.action');

      if(!container.classList.contains('expanded')) {
        container.classList.add('expanded');
        text.innerHTML = "Hide";
      } else {
        container.classList.remove('expanded');
        text.innerHTML = "Show";
      }
    });
  }
  manageContactDetails();
}

export function addQueryString(url, queryString) {
  if (queryString) {
    var isQuestionMarkPresent = url && url.indexOf('?') !== -1,
      separator = isQuestionMarkPresent ? '&' : '?';
    url += separator + queryString;
  }

  return url;
}
